'use strict';

goog.provide("Ntry.initialize");

goog.require("Ntry.InterfaceManager");
goog.require("Ntry.SystemManager");
goog.require("Ntry.EntityManager");
goog.require("Ntry.ConfigManager");
goog.require("Ntry.EventHandler");
/* components */
goog.require("Ntry.Position");
goog.require("Ntry.Grid");
goog.require("Ntry.Sprite");
goog.require("Ntry.Restore");
goog.require("Ntry.Bitmap");
goog.require("Ntry.Tile");
goog.require("Ntry.Unit");
goog.require("Ntry.Code");
goog.require("Ntry.ScriptContainer");
goog.require("Ntry.RunningScript");

/* systems */
goog.require("Ntry.CanvasRenderer");
goog.require("Ntry.GridSystem");
goog.require("Ntry.Interpreter");
goog.require("Ntry.ItemSystem");
goog.require("Ntry.JrItemSystem");
goog.require("Ntry.MazeSystem");
goog.require("Ntry.Playground");
goog.require("Ntry.JrPlayground");
goog.require("Ntry.Engine");
goog.require("Ntry.MazeEngineView");
goog.require("Ntry.JrEngineView");
goog.require("Ntry.Hint");
goog.require("Ntry.MazeIntro");
goog.require("Ntry.JrIntro");
goog.require("Ntry.MazeResult");
goog.require("Ntry.JrResult");
goog.require("Ntry.AiIntro");
goog.require("Ntry.AiResult");
goog.require("Ntry.Ebs2015Intro");
goog.require("Ntry.CodingpartyHint");
goog.require("Ntry.CpartyPlayground");
goog.require("Ntry.JrHint");
goog.require("Ntry.JrHelper");
goog.require("Ntry.CpartyCarResult");
goog.require("Ntry.CpartyJrResult");
goog.require("Ntry.CpartyIntro");
goog.require("Ntry.StudyAiIntro");
goog.require("Ntry.StudyAiResult");
goog.require("Ntry.StudyCarResult");
goog.require("Ntry.StudyIntro");
goog.require("Ntry.StudyMazeIntro");
goog.require("Ntry.StudyMazeJrResult");
goog.require("Ntry.StudyMazeResult");
goog.require("Ntry.MazeStaticIntro");
goog.require("Ntry.MazeStaticResult");

Ntry.initialize = function(options) {
    this._events = {};
    if (this.updateTick)
        clearInterval(this.updateTick);
    this.interfaceManager = new Ntry.InterfaceManager();
    this.entityManager = new Ntry.EntityManager();
    this.systemManager = new Ntry.SystemManager();
    this.configManager = new Ntry.ConfigManager();

    this.registerComponents(options.components);
    this.registerSystems(options.systems);

    this.updateTick = setInterval(Ntry.update, 1000/16);

    this.clear();
};

Ntry.clearNtry = function() {
    this._events = {};
    if (this.updateTick)
        clearInterval(this.updateTick);

    if(this.interfaceManager) {
        this.interfaceManager.removeDom();
    }
    this.unregisterComponents();
    this.unregisterSystems();

    delete this.interfaceManager;
    delete this.entityManager;
    delete this.systemManager;
    delete this.configManager;

    this.clear();
}

Ntry.loadConfig = function(configurations) {
    this.configManager.loadConfig(configurations);
    this.systemManager.updateConfig();
    this.systemManager.update();
    this.interfaceManager.updateConfig();
};

Ntry.registerComponents = function(components) {
    for (var i in components)
        this.entityManager.registerComponent(components[i]);
};

Ntry.registerSystems = function(systems) {
    for (var i in systems)
        this.systemManager.addSystem(systems[i]);
};

Ntry.unregisterComponents = function() {
    if(this.entityManager) {
        this.entityManager.unregisterComponents();
    }
};

Ntry.unregisterSystems = function(systems) {
    if(this.systemManager) {
        this.systemManager.removeAllSystem();
    }
};
